module.exports = __webpack_public_path__ + "static/img/home_map_img1.5928498f.png";